module.exports = __webpack_public_path__ + "img/InstrumentNormal.c0a5cd65.svg";